import supabase from '../supabase/supabase';

export const SALVAGEY_LOGO_SOURCE =
  'https://media-manager-c.questera.ai/greta-media/905f91485ab63acb0ca3d0eb7a8d12edb0e5fd8263e0c7ad4c0bd7710abc0b3f680db9e50b9a6deeaa0ab59826a97d73/images/aW1hZ2UvcG5n/204a49f99f5d6e5a1b638e7b0db8435f.png';

const BUCKET_NAME = 'branding-assets';
const LOGO_PATH = 'salvagey-logo.png';

export const getSalvageyLogoUrl = () => {
  const { data } = supabase.storage.from(BUCKET_NAME).getPublicUrl(LOGO_PATH);
  return data.publicUrl;
};

export const uploadSalvageyLogo = async () => {
  try {
    const response = await fetch(SALVAGEY_LOGO_SOURCE);
    if (!response.ok) return SALVAGEY_LOGO_SOURCE;

    const logoBlob = await response.blob();
    const { error } = await supabase.storage
      .from(BUCKET_NAME)
      .upload(LOGO_PATH, logoBlob, {
        upsert: true,
        cacheControl: '31536000',
        contentType: 'image/png'
      });

    return error ? SALVAGEY_LOGO_SOURCE : getSalvageyLogoUrl();
  } catch (error) {
    console.warn('Unable to save the Salvagey logo to storage:', error);
    return SALVAGEY_LOGO_SOURCE;
  }
};